import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
    grid
    list-inside
    gap-2
  `,
  variants: {
    ordered: {
      true: 'list-decimal',
      false: 'list-disc',
    },
  },
});

export default styles;
